import React, { Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import BottomNav from './components/BottomNav';

// Lazy-loaded page components for code splitting
const Dashboard    = React.lazy(() => import('./pages/Dashboard'));
const MyClimate    = React.lazy(() => import('./pages/MyClimate'));
const BusinessNexus = React.lazy(() => import('./pages/BusinessNexus'));
const CivicPulse   = React.lazy(() => import('./pages/CivicPulse'));

const PageLoader: React.FC = () => (
  <div className="sc-bg" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <div style={{ textAlign: 'center', position: 'relative', zIndex: 1 }}>
      <div className="float" style={{ fontSize: '4rem', marginBottom: '1.5rem' }}>🌍</div>
      <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'center', marginBottom: '1rem' }}>
        {[0, 0.2, 0.4].map((d, i) => (
          <div
            key={i}
            style={{
              width: 10, height: 10, borderRadius: '50%',
              background: 'var(--color-primary)',
              animation: `pulse-ring 1.2s ${d}s ease-out infinite`
            }}
          />
        ))}
      </div>
      <p style={{ color: 'rgba(255,255,255,0.6)', fontFamily: 'Inter, sans-serif', fontSize: '0.9rem' }}>
        Loading climate intelligence…
      </p>
    </div>
  </div>
);

const NotFound: React.FC = () => (
  <div className="sc-bg" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <div style={{ textAlign: 'center', position: 'relative', zIndex: 1 }}>
      <div style={{ fontSize: '6rem', marginBottom: '1rem' }}>🌐</div>
      <h1 style={{ fontSize: '5rem', fontWeight: 900, color: 'rgba(255,255,255,0.15)', margin: 0 }}>404</h1>
      <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: '1.125rem', margin: '1rem 0 2rem' }}>
        This page doesn't exist in our climate model.
      </p>
      <button
        onClick={() => { window.location.hash = '#/'; }}
        className="btn btn-primary"
        style={{ fontSize: '1rem', padding: '0.875rem 2rem' }}
      >
        🏠 Return to Dashboard
      </button>
    </div>
  </div>
);

function App() {
  return (
    <>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/"              element={<Dashboard />} />
          <Route path="/dashboard"     element={<Navigate to="/" replace />} />
          <Route path="/myclimate"     element={<MyClimate />} />
          <Route path="/businessnexus" element={<BusinessNexus />} />
          <Route path="/civicpulse"    element={<CivicPulse />} />
          <Route path="*"              element={<NotFound />} />
        </Routes>
      </Suspense>
      {/* Mobile sticky bottom nav — hidden on desktop via CSS */}
      <BottomNav />
    </>
  );
}

export default App;